<template>
  <div class="featured with-background">
    <b-container class="featured-wrapper">
      <b-row class="no-gutters">
        <b-col class="featured-container">
          <ActiveSlider
            :key="activeSlider.id"
            :id="activeSlider.id"
            :type="activeSlider.type"
            :code="activeSlider.code"
            :model="activeSlider.model"
            :base="activeSlider.base"
            :brand="activeSlider.brand"
            :make="activeSlider.make"
            :cc="activeSlider.cc"
            :color="activeSlider.color"
            :fuel="activeSlider.fuel"
            :mileage="activeSlider.mileage"
            :cilinders="activeSlider.cilinders"
            :doors="activeSlider.doors"
            :keys="activeSlider.keys"
            :source="activeSlider.source"
            :transmission="activeSlider.transmission"
            :flags="activeSlider.flags"
            :images="activeSlider.all_pictures"
            :auction="auction"
          />
          <CarsSlider
            :key="componentKey"
            :cars="cars"
            v-on:select-car="selectCar"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ActiveSlider from "./featured/ActiveSlider";
import CarsSlider from "./featured/CarsSlider";
import utils from "../assets/js/utils";

export default {
  name: "featured",
  components: {
    ActiveSlider,
    CarsSlider,
  },
  props: {
    cars: {
      type: Array,
      default: function() {
        return [];
      },
    },
    properties: {
      type: Object,
      default: function() {
        return {};
      },
    },
    auction: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      componentKey: 1,
      activeSlider: {
        id: "0",
        type: "",
        model: 0,
        base: 0,
        brand: "",
        make: "",
        cc: "",
        color: "",
        fuel: "",
        mileage: "",
        cilinders: "",
        doors: "",
        keys: "",
        source: "",
        code: "",
        transmission: "",
        flags: {},
        all_pictures: [],
      },
    };
  },
  methods: {
    selectCar: function(carId) {
      this.activeSlider = utils.getCar(
        carId,
        this.cars,
        this.properties[carId]
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.featured-container {
  background-color: $white;
  padding: 0;
  position: relative;

  .control-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    > .row {
      height: 100%;

      > div[class^="col-"],
      div[class*=" col-"] {
        height: 100%;
      }
    }

    .control {
      width: 100%;
      padding-top: 56.25%;
      position: relative;

      .control-inner {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 10px;
      }
    }
  }
}
</style>
